import React from 'react';
import { IconProps } from '.';

const SvgSpoid = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.995 14.245 16.75 16l1.346-1.346-1.75-1.75L22 7.25V5.5L18.5 2h-1.75l-5.654 5.654-1.75-1.75L8 7.25l1.755 1.755-5.34 5.34v3.493L2 20.254 3.746 22l2.416-2.416h3.493l5.34-5.34Zm-8.833 3.84-.42.173.174-.42v-2.872l4.845-4.845 3.118 3.118-4.845 4.845H6.162Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSpoid;
